import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { addOrders as AddOrdersAPI} from 'services/apiOrders';

const useAddOrders = () => {
  
    const queryClient = useQueryClient();
    const{isPending,isSuccess, mutate: addOrders} = useMutation({
        mutationFn: AddOrdersAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(['newOrder'],data)
            toast.success("Order Created Successfully")
            queryClient.invalidateQueries({queryKey:['orderList']})
            queryClient.invalidateQueries({queryKey:['dashStatus']})
        },
        onError:(error)=>{
                console.log("Error occurred when creating order",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
        }
    })

    return {isPending, isSuccess, addOrders}
}

export default useAddOrders